import React, { useState, useEffect } from "react";
import axios from "axios";
import "./BidsConfigure.css";

const BidsConfigure = () => {
  const [markets, setMarkets] = useState([]);
  const [bids, setBids] = useState([]);
  const [editingBid, setEditingBid] = useState(null);
  const [formData, setFormData] = useState({
    entryFee: "",
    poolPrizePercent: "",
    firstPrize: "",
    bidSlots: "",
    individualBidCount: "",
    marketId: "",
    prizeMasterList: [], // 👈 new
  });


  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchMarkets();
    fetchBids();
  }, []);

  const fetchMarkets = async () => {
    try {
      const res = await axios.get("https://prod-erp.nifty10.in/get/market");
      setMarkets(res.data.data || []);
    } catch (err) {
      console.error("Error fetching markets:", err);
    }
  };

  const fetchBids = async () => {
    try {
      const res = await fetch("https://prod-erp.nifty10.in/bids/config");
      const json = await res.json();
      setBids(json.data || []);
    } catch (err) {
      console.error("Error fetching bids:", err);
    }
  };

  const handleEditClick = (bid) => {
    const isCombo = bid.marketNames?.includes("Bullish") && bid.marketNames.includes("Bearish");

    setEditingBid(bid);
    setFormData({
      entryFee: bid.entryFee,
      poolPrizePercent: ((bid.poolPrize / (bid.entryFee * bid.bidSlots)) * 100).toFixed(2),
      firstPrize: bid.firstPrize,
      bidSlots: bid.bidSlots,
      individualBidCount: bid.individualBidCount,
      marketId: isCombo
        ? "bullish_bearish_combo"
        : markets.find((m) => m.marketName === bid.marketNames[0])?.marketId || "",
      prizeMasterList: bid.prizeMasterList || [], // ✅ include this
    });

    setErrors({});
  };


  const handleCancel = () => {
    setEditingBid(null);
    setFormData({
      entryFee: "",
      poolPrizePercent: "",
      firstPrize: "",
      bidSlots: "",
      individualBidCount: "",
      marketId: "",
    });
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  };


  const validate = () => {
  const errs = {};
  const {
    entryFee,
    poolPrizePercent,
    firstPrize,
    bidSlots,
    individualBidCount,
    marketId,
  } = formData;

  if (!entryFee) errs.entryFee = "Required";
  if (!poolPrizePercent) errs.poolPrizePercent = "Required";
  if (!firstPrize) errs.firstPrize = "Required";
  if (!bidSlots) errs.bidSlots = "Required";
  if (!individualBidCount) errs.individualBidCount = "Required";
  if (!marketId) errs.marketId = "Required";

  const collected = Number(entryFee) * Number(bidSlots);
  const actualPrizePool = (Number(poolPrizePercent) / 100) * collected;

  if (Number(poolPrizePercent) > 100) {
    errs.poolPrizePercent = "Cannot exceed 100%";
  }

  if (Number(firstPrize) > actualPrizePool) {
    errs.firstPrize = "Cannot be more than the total prize pool";
  }

  setErrors(errs);
  return Object.keys(errs).length === 0;
};

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  try {
    const collected = Number(formData.entryFee) * Number(formData.bidSlots);
    const actualPrizePool = (Number(formData.poolPrizePercent) / 100) * collected;

    // ✅ Fetch all bids having the same entry fee
    const sameEntryFeeBids = bids.filter(
      (bid) => Number(bid.entryFee) === Number(formData.entryFee)
    );

    if (sameEntryFeeBids.length === 0) {
      console.warn("No bids found with the same entry fee.");
      return;
    }

    console.log(`Found ${sameEntryFeeBids.length} bids with entryFee = ${formData.entryFee}`);

    // ✅ Get market info
    const bullishMarket = markets.find(
      (m) => m.marketName.toLowerCase() === "bullish"
    );
    const bearishMarket = markets.find(
      (m) => m.marketName.toLowerCase() === "bearish"
    );

    // Helper to prepare updated payload
    const prepareUpdatedBid = (originalBid, market) => ({
      ...originalBid,
      entryFee: Number(formData.entryFee),
      poolPrize: Math.floor(actualPrizePool),
      firstPrize: Number(formData.firstPrize),
      bidSlots: Number(formData.bidSlots),
      individualBidCount: Number(formData.individualBidCount),
      marketId: market.marketId,
      marketName: market.marketName,
      prizeMasterList: formData.prizeMasterList,
      modifiedBy: "556c3d52-e18d-11ef-9b7f-02fd6cfaf985",
      modifiedDate: new Date().toISOString(),
    });

    // ✅ Split logic based on market selection
    let updates = [];

    if (formData.marketId === "bullish_bearish_combo") {
      // ⚡ Split equally between bullish and bearish
      const half = Math.ceil(sameEntryFeeBids.length / 2);

      sameEntryFeeBids.forEach((bid, idx) => {
        const targetMarket = idx < half ? bullishMarket : bearishMarket;
        updates.push(prepareUpdatedBid(bid, targetMarket));
      });
    } else {
      // ⚡ All same-entry-fee bids to same market (bullish OR bearish)
      const targetMarket = markets.find((m) => m.marketId === formData.marketId);
      sameEntryFeeBids.forEach((bid) => {
        updates.push(prepareUpdatedBid(bid, targetMarket));
      });
    }

    // ✅ Sequentially send updates
    for (const updatedBid of updates) {
      console.log(`🔄 Updating ${updatedBid.marketName} bid (bidId: ${updatedBid.bidId})...`);
      await axios.post("https://prod-erp.nifty10.in/bids/update", updatedBid, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      console.log(`✅ ${updatedBid.marketName} updated successfully`);
    }

    console.log("✅ All same-entry-fee bids updated successfully!");
    fetchBids();
    handleCancel();
  } catch (err) {
    console.error("❌ Update failed:", err);
  }
};



  const merged = [];
  bids.forEach((b) => {
    const key = `${b.bidName}-${b.entryFee}-${b.bidSlots}-${b.poolPrize}`;
    const exist = merged.find((m) => m._key === key);
    if (exist) {
      if (!exist.marketNames.includes(b.marketName)) {
        exist.marketNames.push(b.marketName);
      }
    } else {
      merged.push({ ...b, _key: key, marketNames: [b.marketName] });
    }
  });

  merged.sort((a, b) => new Date(b.modifiedDate) - new Date(a.modifiedDate));

  const displayBids = merged.map((b) => {
    const hasBull = b.marketNames.includes("Bullish");
    const hasBear = b.marketNames.includes("Bearish");
    return {
      ...b,
      displayName: hasBull && hasBear ? "Bullish & Bearish" : b.marketNames.join(", "),
    };
  });
  const handlePrizeChange = (index, field, value) => {
    const updated = [...formData.prizeMasterList];
    updated[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      prizeMasterList: updated,
    }));
  };

  const addPrizeLevel = () => {
    setFormData((prev) => ({
      ...prev,
      prizeMasterList: [
        ...prev.prizeMasterList,
        {
          level: prev.prizeMasterList.length + 1,
          prize: "",
          userCount: "",
        },
      ],
    }));
  };

  const removePrizeLevel = (index) => {
    const updated = formData.prizeMasterList.filter((_, i) => i !== index);
    updated.forEach((p, i) => (p.level = i + 1)); // Re-index
    setFormData((prev) => ({
      ...prev,
      prizeMasterList: updated,
    }));
  };

  return (
    <div className="uni-main-container">
      {editingBid ? (
        <div className="uni-bid-form-container1">
          <h3 className="uni-form-heading">Edit Bid</h3>
          <form onSubmit={handleSubmit} className="uni-bid-form-grid">
            {[
              { label: "Entry Fee", name: "entryFee" },
              { label: "Prize Pool (%)", name: "poolPrizePercent" },
              { label: "First Prize", name: "firstPrize" },
              { label: "Bid Slots", name: "bidSlots" },
              { label: "Individual Count", name: "individualBidCount" },
            ].map(({ label, name }) => (
              <div className="uni-form-group" key={name}>
                <label>{label}</label>
                <input
                  type="number"
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                />
                {errors[name] && <p className="uni-error-text">{errors[name]}</p>}
              </div>
            ))}
            <div className="uni-form-group">
              <label>Market</label>
              <select name="marketId" value={formData.marketId} onChange={handleChange}>
                <option value="">Select Market</option>
                <option value="bullish_bearish_combo">Bullish & Bearish</option> {/* Combo option */}
                {markets.map((m) => (
                  <option key={m.marketId} value={m.marketId}>
                    {m.marketName}
                  </option>
                ))}
              </select>

              {errors.marketId && <p className="uni-error-text">{errors.marketId}</p>}
            </div>
            <div className="uni-form-group" style={{ gridColumn: "1 / span 2" }}>
              <h3 className="uni-section-title">Prize Breakdown</h3>

              {/* Scrollable wrapper */}
              <div className="uni-table-responsive">
                <table className="uni-prize-breakdown-table">
                  <thead>
                    <tr>
                      <th>Level</th>
                      <th>Prize Amount</th>
                      <th>User Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.prizeMasterList.map((prize, index) => (
                      <tr key={index}>
                        <td>Lvl {prize.level}</td>
                        <td>
                          <input
                            type="number"
                            value={prize.prize}
                            onChange={(e) => handlePrizeChange(index, "prize", e.target.value)}
                            disabled={index === 0}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={prize.userCount}
                            onChange={(e) => handlePrizeChange(index, "userCount", e.target.value)}
                          />
                        </td>
                        <td>
                          {index !== 0 && (
                            <button type="button" className="uni-remove-button" onClick={() => removePrizeLevel(index)}>
                              Remove
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <button type="button" onClick={addPrizeLevel} className="uni-add-row-button1">
                Add Row
              </button>
            </div>


            <div
              className="uni-form-group uni-submit-container"
              style={{
                gridColumn: "1 / span 2",
                display: "flex",
                flexDirection: "row",
              }}
            ><div className="button-button">
                <button
                  type="button"
                  className="uni-remove-button1"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button type="submit" className="uni-submit-button1">
                  Save
                </button></div>
            </div>
          </form>
        </div>
      ) : (
        <div className="bids-table-container">
          <h2 className="uni-form-heading">Bid Configure</h2>
          <table className="uni-bids-table">
            <thead>
              <tr>
                <th>Entry Fee</th>
                <th>Prize Pool (%)</th>
                <th>First Prize</th>
                <th>Bid Slots</th>
                <th>Market</th>
                <th>Active</th>
                <th>Individual Slots</th>
                <th>Created Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {displayBids.map((bid) => {
                const amountCollected = bid.entryFee * bid.bidSlots;
                const poolPercentage = amountCollected
                  ? ((bid.poolPrize / amountCollected) * 100).toFixed(2)
                  : "0.00";

                return (
                  <tr key={bid._key}>
                    <td data-label="Entry Fee">{bid.entryFee}</td>
                    <td data-label="Prize Pool (%)">{poolPercentage}%</td>
                    <td data-label="First Prize">₹ {bid.firstPrize}</td>
                    <td data-label="Bid Slots">{bid.bidSlots}</td>
                    <td data-label="Market">{bid.displayName}</td>
                    <td data-label="Active">{bid.active ? "✅" : "❌"}</td>
                    <td data-label="Individual Slots">{bid.individualBidCount}</td>
                    <td data-label="Created Date">{new Date(bid.createdDate).toLocaleDateString("en-GB")}</td>
                    <td data-label="Action">
                      <button
                        className="uni-add-row-button"
                        onClick={() => handleEditClick(bid)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>

          </table>
        </div>
      )}
    </div>
  );
};

export default BidsConfigure;
